import React from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal } from './ui/ScrollReveal';
export function ShowcaseGallery() {
  return <section className="py-24 bg-brand-green-deep overflow-hidden" data-id="element-459">
      <div className="max-w-[1400px] mx-auto px-6" data-id="element-460">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6" data-id="element-461">
          {/* Large Featured Image */}
          <div className="md:col-span-8 h-[600px] relative rounded-2xl overflow-hidden group" data-id="element-462">
            <ScrollReveal delay={0.1} className="w-full h-full" data-id="element-463">
              <motion.img whileHover={{
              scale: 1.05
            }} transition={{
              duration: 0.8,
              ease: 'easeOut'
            }} src="https://cdn.magicpatterns.com/uploads/3b62EKAAjmaPYQxrkuwQqy/estategreen.png" alt="Estate Green Showcase" className="w-full h-full object-cover" data-id="element-464" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent pointer-events-none" data-id="element-465" />
              <div className="absolute bottom-8 left-8 right-8 pointer-events-none" data-id="element-466">
                <span className="text-brand-gold text-xs font-bold tracking-[0.2em] uppercase mb-2 block" data-id="element-467">
                  Featured Project
                </span>
                <h3 className="text-3xl md:text-4xl font-heading text-brand-cream-light" data-id="element-468">
                  The Estate Collection
                </h3>
              </div>
            </ScrollReveal>
          </div>

          {/* Small Top Right */}
          <div className="md:col-span-4 h-[600px] flex flex-col gap-6" data-id="element-469">
            <div className="flex-1 relative rounded-2xl overflow-hidden group" data-id="element-470">
              <ScrollReveal delay={0.2} className="w-full h-full" data-id="element-471">
                <motion.img whileHover={{
                scale: 1.05
              }} transition={{
                duration: 0.8,
                ease: 'easeOut'
              }} src="https://cdn.magicpatterns.com/uploads/tvAkCsifm3oKpj9V73sDzg/sunet_green.png" alt="Sunset Green Showcase" className="w-full h-full object-cover" data-id="element-472" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent pointer-events-none" data-id="element-473" />
                <div className="absolute bottom-6 left-6 pointer-events-none" data-id="element-474">
                  <h3 className="text-xl font-heading text-brand-cream-light" data-id="element-475">
                    Coastal Concepts
                  </h3>
                </div>
              </ScrollReveal>
            </div>

            {/* Small Bottom Right */}
            <div className="flex-1 relative rounded-2xl overflow-hidden group" data-id="element-476">
              <ScrollReveal delay={0.3} className="w-full h-full" data-id="element-477">
                <motion.img whileHover={{
                scale: 1.05
              }} transition={{
                duration: 0.8,
                ease: 'easeOut'
              }} src="https://cdn.magicpatterns.com/uploads/o2kbb1M8SM3uegyLFntqUo/wedding_golf.png" alt="Wedding Green Showcase" className="w-full h-full object-cover" data-id="element-478" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent pointer-events-none" data-id="element-479" />
                <div className="absolute bottom-6 left-6 pointer-events-none" data-id="element-480">
                  <h3 className="text-xl font-heading text-brand-cream-light" data-id="element-481">
                    Event Activations
                  </h3>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </div>
    </section>;
}